import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchShops,addShop,updateShop, clearAlerts,clearSelectedShop} from "../../store/shopSlice";
// import { useSnackbar } from '../MySnackbar';


import {
  TextField,
  Button,
  Box,
  FormControl,
} from "@mui/material";
import MySelect from "../MySelect";

const ShopForm = ({closeDialog}) => {

  const dispatch= useDispatch();

    const {message,error,selectedShop}=useSelector((state) => state.shop);
    const {users}=useSelector((state) => state.user);

  

  const [form, setForm] = useState({

        id:selectedShop?._id||-1,
        name: selectedShop?.name||"",
        owner: selectedShop?.owner||"",
        location:selectedShop?.location|| "",
        users: selectedShop?.users?.map((user) => user._id) || [],

  });

  const clearForm=()=>{
    setForm(
      {
        id:-1,
        name: "",
        owner: "",
        location: "",
        users: [],
      }
    )
  }

    useEffect(() => {

        
        return () => {
    
              dispatch(clearAlerts());
              dispatch(clearSelectedShop())
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
      

    useEffect(() => {
      if (message || error) {
       
          clearForm();
          dispatch(fetchShops({page:1,limit:5}));
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [message, error]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleUserChange = (e) => {
    const { value } = e.target;
    setForm({ ...form, users: typeof value === "string" ? value.split(",") : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if(selectedShop){
      dispatch(updateShop(form))
    }else{
        dispatch(addShop(form))
    }
  };


  

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", p: 3, border: "1px solid #ddd", borderRadius: 2 }}>

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Shop Name"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
          sx={{ mb: 3 }}
        />
        <TextField
          fullWidth
          label="Location"
          name="location"
          value={form.location}
          onChange={handleChange}
          required
          sx={{ mb: 3 }}
        />
    
        <FormControl fullWidth  sx={{ mb: 3 }}>
         
      <MySelect
        label="Select Users for this shop"
        options={users}
        value={form.users}
        onChange={handleUserChange}
        multiple={true}
        getOptionValue={(option) => option._id}
        getOptionLabel={(option) => option.login}
      />
        </FormControl>
        <Button variant="contained" type="submit" fullWidth>
          {selectedShop?"Update Shop":"Create Shop"}
        </Button>
        <br/><br/>
  
      </form>
    </Box>
  );
};

export default ShopForm;
